<script>
  import Page from "./Page.svelte";
  import Loader from "./Loader.svelte";
  import { auth, googleProvider } from "../firebase";
  import {navigateTo } from "yrv";
  import { authState } from "rxfire/auth";

  let user;
  const unsubscribe = authState(auth).subscribe(u => (user = u));

  auth.onAuthStateChanged(user => {
    if (user) {
      navigateTo("/");
    }
  });
</script>


<Page>
  <Loader />
</Page>
